document.addEventListener('DOMContentLoaded', function () {
  // --- Helpers ---
  function fmtKg(g){
    return (g/1000).toLocaleString(undefined, { maximumFractionDigits: 1 }) + ' kg';
  }
  function priceFromWeight(g){
    if (g === 0)          return 'kostenlos';
    if (g <=  30000)      return '10 €';
    if (g <= 100000)      return '59 €';
    if (g <= 300000)      return '99 €';
    if (g <= 500000)      return '159 €';
    if (g <= 1000000)     return '209 €';
    if (g <= 1500000)     return '399 €';
    if (g <= 2000000)     return '419 €';
    if (g <= 2500000)     return '559 €';
    return 'Auf Anfrage';
  }

  function updateWeights(grams){
    var human = fmtKg(grams || 0);
    document.querySelectorAll('.js-variant-weight, #dynamic-weight').forEach(function(el){
      // „Gewicht: “-Präfix beibehalten, wenn es bereits im Knoten steht
      var hasPrefix = /gewich/i.test(el.textContent);
      el.textContent = (hasPrefix ? 'Gewicht: ' : '') + human;
    });
  }

  function updateShippingPrice(grams){
    var priceEl = document.getElementById('ship-price');
    if (!priceEl) return; // optional – nur wenn vorhanden
    priceEl.textContent = priceFromWeight(grams || 0);
  }

  function updateAllByVariant(v){
    if (!v) return;
    var g = v.weight || 0;
    updateWeights(g);
    updateShippingPrice(g);
  }

  // --- 1) Modernes Dawn: Event beim Variantenwechsel ---
  document.addEventListener('variant:change', function(e){
    updateAllByVariant(e.detail && e.detail.variant);
  });

  // --- 2) Fallback: Radio-Inputs (manche Themes/Abschnitte) ---
  document.querySelectorAll('input[name="id"]').forEach(function (el) {
    el.addEventListener('change', function(){
      var id = this.value;

      // a) Aus Dawns Produkt-JSON holen (falls verfügbar)
      try {
        var prod = window.__PRODUCT_JSON__;
        if (prod && Array.isArray(prod.variants)) {
          var v = prod.variants.find(function(x){ return String(x.id) === String(id); });
          if (v) { updateAllByVariant(v); return; }
        }
      } catch(_) {}

      // b) Fallback: aus altem Array variantsWithUnits Gramm schätzen
      if (Array.isArray(window.variantsWithUnits)) {
        var hit = window.variantsWithUnits.find(function(x){ return String(x.id) === String(id); });
        if (hit && hit.weight_with_unit) {
          var m = hit.weight_with_unit.match(/([\d.,]+)\s*kg/i);
          var grams = m ? Math.round(parseFloat(m[1].replace(',','.')) * 1000) : 0;
          updateWeights(grams);
          updateShippingPrice(grams);
        }
      }
    });
  });
});
